<template>
    <div class="products-promotion-create">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.go(-1);">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">Create Promotion</div>
                    </div>

                    <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                        Promotion created successfully.
                    </div>

                    <div class="col-md-4">
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container">
            <h3 class="section-title mt-5">Basic Details</h3>

             <form @submit.prevent="checkForm" action="#" method="post">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.promotionData.name.$error }">
                            <label for="">Promotion name *</label>
                            <input class="form-control" v-model.trim="$v.promotionData.name.$model" type="text">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.promotionData.valid.$error }">
                            <label for="">Valid *</label>
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input  v-model.trim="$v.promotionData.valid.$model" id="active" type="radio" name="status" value="1" required class="custom-control-input">
                                    <label class="" for="active">Active</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input  v-model.trim="$v.promotionData.valid.$model" id="inactive" type="radio" name="status" value="0" required class="custom-control-input">
                                    <label class="" for="inactive">Inactive</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.promotionData.valid.$error }">
                            <label for="">Promotion Starts *</label>
                            <datepicker v-model.trim="$v.promotionData.start_date.$model" :format="customFormatter"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.promotionData.valid.$error }">
                            <label for="">Promotion Ends *</label>
                            <datepicker v-model.trim="$v.promotionData.end_date.$model" :format="customFormatter"></datepicker>
                        </div>
                    </div>
                </div>

                <h3 class="section-title mt-5">Target Area</h3>

                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Division</label>
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input id="north" type="checkbox" name="division" value="0" class="custom-control-input" v-model="division" @change="onChangeDivision()">
                                    <label class="" for="north">East</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input id="south" type="checkbox" name="division" value="1" class="custom-control-input" v-model="division" @change="onChangeDivision()">
                                    <label class="" for="south">West</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Region</label>
                            <app-multi-select 
                                :options="regionOptions.map(regionOption => regionOption.id)"
                                :custom-label="opt => regionOptions.find(x => x.id == opt).name"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true" 
                                :preselect-first="false"
                                :placeholder="'-- All Region --'"
                                v-model="region"
                                @input="onChangeRegion">
                                    <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                            </app-multi-select>

                            <div class="selected-label" v-if="region.length > 0">
                                FILTER:
                                <div v-for="region in region" :key="region">{{ regionOptions.find(x => x.id == region).name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <!-- <div class="form-group" :class="{ 'form-is-error': $v.promotionData.area_ids.$error }"> -->
                        <div class="form-group">
                            <label for="">Area *</label>
                            <div class="custom-modal-select" :class="{ 'selected': promotionData.area_ids.length > 0 }" v-b-modal.area-modal>
                                <input type="button" class="form-control" :value="promotionData.area_ids.length > 0 ? promotionData.area_ids.length + ' selected' : '-- All Area --'">
                            </div>

                            <div class="selected-label" v-if="promotionData.area_ids.length > 0">
                                FILTER:
                                <div v-for="area in promotionData.area_ids" :key="area">{{ areaOptions.find(x => x.id == area).name}}</div>
                            </div>

                            <!-- <div class="invalid-feedback form-error-msg" v-if="!$v.promotionData.area_ids.required">Primary area is required</div> -->
                        </div>
                    </div>
                </div>

                <h3 class="section-title mt-5">Select Promotion Product(s)</h3>

                <div class="table-responsive">
                    <table class="table table-striped result-table table-form">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="w-15">Brand</th>
                                <th class="w-20">Product</th>
                                <th class="text-right">Base Selling Price per Unit</th>
                                <th class="w-10 text-right">QTY</th>
                                <th class="text-right">Total Base Selling Price</th>
                                <th class="text-right">Total Promo Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :key="item.id" v-for="(item, index) in selectedProducts">
                                <td>
                                    <div class="remove-row" v-if="selectedProducts.length > 1" @click="removeProduct(index)">Remove</div>
                                </td>
                                <td>
                                    <select v-model="item.selectedBrand" @change="onRangeChange(item)" class="custom-select form-control" name="brand" id="brand" required>
                                        <option value="1">Dunhill</option>
                                        <option value="2">Lucky Strike</option>
                                        <option value="3">Others</option>
                                    </select>
                                </td>
                                <td>
                                    <select class="custom-select form-control" name="selectedProduct" id="selectedProduct" v-model="item.selectedProduct" required>
                                        <option v-for="product in item.products" v-bind:key="product.id" :value="product">{{ product.name }}</option>
                                    </select>
                                </td>
                                <td class="text-right">
                                    <span v-if="!item.selectedProduct">0</span>
                                    <span v-else>{{item.selectedProduct.price}}</span>
                                </td>
                                <td>
                                    <input class="form-control text-right" type="number" @keyup="quantityOnChange(item.quantity)" @keydown="filterKey" @input="filterInput" v-model="item.quantity" min="1" value="1" required>
                                </td>
                                <td class="text-right">
                                    <span v-if="!item.selectedProduct">0</span>
                                    <span v-else>{{item.selectedProduct.price * item.quantity}}</span>
                                </td>
                                <td>
                                    <input @keyup="countTotal" @keydown="filterKey" @input="filterInput" v-model="item.promo_price" class="form-control text-right" type="number" required>
                                </td>
                            </tr>

                            <tr class="table-footer">
                                <td colspan="4">
                                    <button @click="addProduct" type="button" class="btn btn-link p-0">
                                        <span class="icon-plus">Add</span> Add Products
                                    </button>
                                </td>
                                <td colspan="2" class="text-right">Grand Total Promo Price</td>
                                <td class="text-right">{{totalPrice}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <button class="mt-5 btn btn-ecdc btn-shadow">Create</button>

            </form>
            
        </div>

        <b-modal id="area-modal" hide-header hide-footer centered size="xl">
            <img src="../assets/img/icon-close.png" alt="icon-close" class="img-fluid modal-close" @click="$bvModal.hide('area-modal')" /> 

            <div class="selection-modal">
                <h4 class="title text-left mb-5">Area</h4>

                <div class="form-group">
                    <div class="row">
                        <div v-for="areaOption in areaOptions" v-bind:key="areaOption.id" class="col-4 col-xl-2">
                            <div class="custom-control custom-checkbox form-check-inline">
                                <input class="custom-control-input" type="checkbox" :id="'inlineCheckbox' + areaOption.id" :value="areaOption.id" v-model="promotionData.area_ids">
                                <label class="custom-control-label" :for="'inlineCheckbox' + areaOption.id">{{ areaOption.name }}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <button type="button" class="btn btn-ecdc" @click="$bvModal.hide('area-modal')">Done</button>
                    <button type="button" class="btn btn-link text-muted" @click="clearArea()">Clear Selection</button>
                </div>
            </div>
        </b-modal>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getRegions, getAreas, getBatProducts, storePromotion } from '../api'
import Datepicker from 'vuejs-datepicker';
import Loader from './Loader.vue'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        appLoader: Loader,
        Datepicker,
        appMultiSelect: Multiselect
    },
    data() {
        return {
            promotionData: {
                name: "",
                valid: "",
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                price: 0,
                products: [],
                area_ids: []
            },
            selectedProducts: [
                {
                    selectedBrand:1,
                    products:[],
                    selectedProduct: [],
                    product_id: "",
                    quantity: 1,
                    promo_price: 0
                }
            ],
            division: [],
            region: [],
            regions: [],
            regionOptions: [],
            areas: [],
            areaOptions: [],
            productsList: [],
            isDivisionRestrict: true,
            isRegionRestrict: true,
            isAreaRestrict: true,
            isLoading: true,
            isError: false,
            isSuccess: false,
            totalPrice: 0
        }
    },
    validations: {
        promotionData: {
            name: {
                required
            },
            valid: {
                required
            },
            start_date: {
                required
            },
            end_date: {
                required
            }
        }
    },
    async mounted() {
        await this.getRegions();
        await this.getAreas();
        await this.getBatProducts();
        this.onRangeChange(this.selectedProducts[0]);
        this.isLoading = false;
    },
    methods: {
        async getBatProducts() {

            try {
                const result = await getBatProducts();
                this.productsList = result.data.data.result;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getRegions() {

            try {
                const result = await getRegions();
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) { 
                alert(err.response.data.message);
            }
        },
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.region = [];
            this.areaOptions = this.areas;
            this.promotionData.area_ids = [];

           if(this.division.length > 0) {

                this.division.forEach(division => {
                    const found = _this.regions.filter(value => value.division == division);

                    found.forEach(value => {
                        _this.regionOptions.push(value);
                    });
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.promotionData.area_ids = [];

            if(this.region.length > 0) {

                this.region.forEach(region => {

                    const found = _this.areas.filter(value => value.region_id == region);
                    
                    found.forEach(value => {
                        _this.areaOptions.push(value);
                    });
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        onRangeChange(item) {
            
            item.products = [];
            item.selectedProduct = [];

            if(item.selectedBrand) {

                const found = this.productsList.filter(value => value.brand_id == item.selectedBrand);
                
                found.forEach(value => {
                    item.products.push(value);
                });
            }
            else {

                item.products = this.productsList;
            }
        },
        clearArea() {
            
            this.promotionData.area_ids = [];
        },
        filterKey(e) {
            const key = e.key;

            if (key === '.')
                return e.preventDefault();
            
            if (key === 'e')
                return e.preventDefault();
        },     
        filterInput(e) {

            e.target.value = e.target.value.replace(/[^0-9]+/g, '');
        },
        async checkForm() {
            
            const _this = this;

            this.$v.promotionData.$touch();

            if(this.$v.promotionData.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }
            else {

                this.isLoading = true;

                try {
                    this.promotionData.products = this.selectedProducts;
                    this.promotionData.start_date = this.customFormatter(this.promotionData.start_date);
                    this.promotionData.end_date = this.customFormatter(this.promotionData.end_date);
                    
                    this.promotionData.price =0;
                    this.selectedProducts.forEach(function(product){
                        product.product_id = product.selectedProduct.id;
                        _this.promotionData.price = _this.promotionData.price + product.promo_price * product.quantity;
                    });
                    this.promotionData.price = this.totalPrice;

                    await storePromotion(this.promotionData);

                    this.isSuccess = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isSuccess = false;
                        _this.$router.push({ name: "productsPromotionDetails" });
                    }, 2000);
                }
                catch(err) {
                    alert(err);
                }

                this.isLoading = false;
            }
        },
        addProduct() {
            let object = {
                selectedBrand:1,
                products:[],
                selectedProduct: [],
                product_id: "",
                quantity: 1,
                promo_price: 0
            };

            this.onRangeChange(object);
            this.selectedProducts.push(object);
        },
        removeProduct(index) {

            this.selectedProducts.splice(index, 1);
            this.countTotal();
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        countTotal() {
            const _this = this;
            this.totalPrice = 0;
            if (this.selectedProducts.length) {
                this.selectedProducts.forEach(function(product){

                    if(product.promo_price == "") {
                        product.promo_price = 0;
                    }

                    _this.totalPrice = _this.totalPrice + parseInt(product.promo_price);
                });
            }
        },
        quantityOnChange(quantity) {

            if(quantity == "") {
                quantity = 0;
            }
        }
    }
}
</script>